import apiClient from './api';

export interface AffiliateInfo {
    code: string;
    commissionRate: number;
    active: boolean;
    windowMonths: number;
    since: string;
}

export interface AffiliateMe {
    affiliate: AffiliateInfo | null;
    totals?: { referrals: number; earned: number; paid: number; balance: number };
    commissions?: Array<{ id: string; baseAmount: number; rate: number; amount: number; createdAt: string }>;
    payouts?: Array<{ id: string; amount: number; note: string | null; paidAt: string }>;
    signups?: string[];
}

export interface ApplyCodeResult {
    type: 'referral';
    applied: boolean;
    message: string;
    code?: string;
    credits?: number;
}

export interface TopupVoucherQuote {
    code: string;
    bonusPercent: number | null;
    bonusCredits: number;
}

/** The signup "Referral code" box and the Top up dialog's voucher field. */
export const codesService = {
    async apply(code: string): Promise<ApplyCodeResult> {
        const res = await apiClient.post('/account/codes/apply', { code });
        return res.data?.data;
    },
    async quoteTopup(code: string, credits: number): Promise<TopupVoucherQuote> {
        const res = await apiClient.get('/account/codes/topup-voucher', { params: { code, credits } });
        return res.data?.data;
    },
};

export const affiliateService = {
    async me(): Promise<AffiliateMe> {
        const res = await apiClient.get('/affiliate/me');
        return res.data?.data ?? { affiliate: null };
    },
    async attribute(code: string): Promise<{ attributed: boolean }> {
        const res = await apiClient.post('/affiliate/attribute', { code });
        return res.data?.data ?? { attributed: false };
    },
};
